'use client';
import { Ctext } from '@/components/ui/Ctext';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { getRadiusCssValue } from '@/theme/radius';
import { pxToRem } from '@/theme/spacing';
import type { CSSProperties, ReactElement } from 'react';
import { FAKE_COMMENT_AUTO_MARGIN } from './cfakecommentConstants';
const NO_TEAM_ROLE_VALUE = "no-team-role";
interface FakeCommentHeaderProps {
    name: string;
    model?: string;
    teamRole?: string | null;
    iconColumn: ReactElement;
    shouldShowTeamRole: boolean;
    isMobile: boolean;
}
function getTeamRoleStyle(isMobile: boolean): CSSProperties | undefined {
    return isMobile
        ? {
            backgroundColor: 'rgba(102, 254, 193, 0.4)',
            borderRadius: getRadiusCssValue(30),
            padding: `${pxToRem(3)} ${pxToRem(10)}`,
            boxShadow: 'rgba(255, 255, 255, 1) 1px 1px 2px -1px inset',
        }
        : undefined;
}
export function FakeCommentHeader({ name, model, teamRole, iconColumn, shouldShowTeamRole, isMobile, }: FakeCommentHeaderProps): ReactElement {
    const authorIdentity = `${name}-${teamRole ?? NO_TEAM_ROLE_VALUE}`;
    return <>
	            <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: pxToRem(8),
        }}>
                {isMobile && iconColumn}
	                <Ctext size={17} weight={FontWeight.SemiBold} color={ColorType.White} opacity={1}>
                    {name}
                </Ctext>
                {model && (<Ctext size={15} weight={FontWeight.Regular} color={ColorType.Accent} opacity={1}>
                        {model}
                    </Ctext>)}
                {shouldShowTeamRole && isMobile && (<div style={{ display: 'flex', marginLeft: FAKE_COMMENT_AUTO_MARGIN }}>
	                        <Ctext size={15} weight={FontWeight.Medium} color={ColorType.White} opacity={1} style={getTeamRoleStyle(isMobile)}>
                            {teamRole}
                        </Ctext>
                    </div>)}
            </div>

            {shouldShowTeamRole && !isMobile && (<div style={{
                display: 'flex',
            }}>
	                    <Ctext size={15} weight={FontWeight.Regular} color={ColorType.White} opacity={0.6} style={getTeamRoleStyle(isMobile)}>
                        {teamRole}
                    </Ctext>
                </div>)}
        </>
        ;
}
